import { Link } from "react-router-dom";
import { formatMoney } from "../../api/money";
import { useBuildPreIssuedBoq, type PreIssuedSummary } from "../../api/sites";
import { StatusChip } from "../../components/ui";

/** The site's pre-issued BOQ, for the office: the bill, whether the visit has
 * confirmed it yet, its total, and the action that builds it -- or rebuilds it
 * from the kit while it is still the office's to change. A refusal (the bill
 * is with the City, or a quotation reprices it) is the server's sentence. */
export default function PreIssuedBoqFact({ siteId, summary }: { siteId: number; summary: PreIssuedSummary | null }) {
  const build = useBuildPreIssuedBoq(siteId);
  const offer = summary === null || summary.can_rebuild;
  return (
    <div className="site-facts-wide">
      <dt>Pre-issued BOQ</dt>
      <dd>
        {summary === null ? (
          <span className="muted">None yet</span>
        ) : (
          <>
            <Link to={summary.url}>{summary.name}</Link>{" "}
            {summary.provisional ? <StatusChip tone="warn">Provisional</StatusChip> : null}{" "}
            {`${formatMoney(summary.total_excl_vat)} excl VAT`}
          </>
        )}
        {offer ? (
          <>
            {" "}
            <button type="button" className="row-button" disabled={build.isPending} onClick={() => build.mutate()}>
              {summary === null ? "Build pre-issued BOQ" : "Rebuild from the kit"}
            </button>
          </>
        ) : null}
        {build.isError ? <span className="line-warn"> {build.error.message}</span> : null}
        {build.data && build.data.notes.length > 0 ? (
          <ul className="cm-notes">
            {build.data.notes.map((note) => (
              <li key={note}>{note}</li>
            ))}
          </ul>
        ) : null}
      </dd>
    </div>
  );
}
